import { useGetEmployeeConfigurationQuery } from "web/features/employee/employeeApiSlice";

const useSubscriptionsView = () => {
  const { data: employeeConfig, isLoading } =
    useGetEmployeeConfigurationQuery();
  const {
    enableMobilePreview: enableMobilePreviewFromConfig,
    enableMobilePreviewUMS,
    enableNewSubscriptionUI: enableNewSubscriptionUIFromConfig,
    enableNewSubscriptionUIUMS,
  } = employeeConfig || {};

  return {
    isLoading,
    enableMobilePreview:
      enableMobilePreviewFromConfig || enableMobilePreviewUMS,
    enableNewSubscriptionUI:
      enableNewSubscriptionUIFromConfig || enableNewSubscriptionUIUMS,
  };
};

export default useSubscriptionsView;
